"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabletCaption = exports.tabletBodySmall = exports.tabletBodyMedium = exports.tabletBodyLarge = exports.tabletSubtitleMedium = exports.tabletSubtitleLarge = exports.tabletTitle4 = exports.tabletTitle3 = exports.tabletTitle2 = exports.tabletLargeTitle = exports.mobileCaption = exports.mobileBodySmall = exports.mobileBodyMedium = exports.mobileBodyLarge = exports.mobileSubtitleMedium = exports.mobileSubtitleLarge = exports.mobileTitle4 = exports.mobileTitle3 = exports.mobileTitle2 = exports.mobileLargeTitle = exports.desktopCaption = exports.desktopBodySmall = exports.desktopBodyMedium = exports.desktopBodyLarge = exports.desktopSubtitleMedium = exports.desktopSubtitleLarge = exports.desktopTitle4 = exports.desktopTitle3 = exports.desktopTitle2 = exports.desktopLargeTitle = void 0;
exports.desktopLargeTitle = {
  fontFamily: 'Roboto',
  fontWeight: 900,
  lineHeight: '125%',
  fontSize: 48,
  letterSpacing: 0
};
exports.desktopTitle2 = {
  fontFamily: 'Roboto',
  fontWeight: 900,
  lineHeight: '133%',
  fontSize: 30,
  letterSpacing: 0
};
exports.desktopTitle3 = {
  fontFamily: 'Roboto',
  fontWeight: 900,
  lineHeight: '133%',
  fontSize: 24,
  letterSpacing: 0
};
exports.desktopTitle4 = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '145%',
  fontSize: 16,
  letterSpacing: 0.3
};
exports.desktopSubtitleLarge = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '133%',
  fontSize: 14,
  letterSpacing: 0.3
};
exports.desktopSubtitleMedium = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '125%',
  fontSize: 12,
  letterSpacing: 0.3
};
exports.desktopBodyLarge = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '150%',
  fontSize: 16,
  letterSpacing: 0
};
exports.desktopBodyMedium = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  lineHeight: '145%',
  fontSize: 14,
  letterSpacing: 0
};
exports.desktopBodySmall = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  lineHeight: '133%',
  fontSize: 12,
  letterSpacing: 0
};
exports.desktopCaption = {
  fontFamily: 'Roboto',
  fontWeight: 700,
  lineHeight: '133%',
  fontSize: 10,
  letterSpacing: 0,
  textCase: ''
};
exports.mobileLargeTitle = {
  fontFamily: 'Roboto',
  fontWeight: 900,
  lineHeight: '133%',
  fontSize: 24,
  letterSpacing: 0
};
exports.mobileTitle2 = {
  fontFamily: 'Roboto',
  fontWeight: 900,
  lineHeight: '150%',
  fontSize: 20,
  letterSpacing: 0
};
exports.mobileTitle3 = {
  fontFamily: 'Roboto',
  fontWeight: 700,
  lineHeight: '150%',
  fontSize: 16,
  letterSpacing: 0
};
exports.mobileTitle4 = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '145%',
  fontSize: 16,
  letterSpacing: 0.3
};
exports.mobileSubtitleLarge = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '133%',
  fontSize: 14,
  letterSpacing: 0.3
};
exports.mobileSubtitleMedium = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '125%',
  fontSize: 12,
  letterSpacing: 0.3
};
exports.mobileBodyLarge = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '150%',
  fontSize: 16,
  letterSpacing: 0
};
exports.mobileBodyMedium = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  lineHeight: '145%',
  fontSize: 14,
  letterSpacing: 0
};
exports.mobileBodySmall = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  lineHeight: '133%',
  fontSize: 12,
  letterSpacing: 0
};
exports.mobileCaption = {
  fontFamily: 'Roboto',
  fontWeight: 700,
  lineHeight: '133%',
  fontSize: 10,
  letterSpacing: 0,
  textCase: ''
};
exports.tabletLargeTitle = {
  fontFamily: 'Roboto',
  fontWeight: 900,
  lineHeight: '133%',
  fontSize: 30,
  letterSpacing: 0
};
exports.tabletTitle2 = {
  fontFamily: 'Roboto',
  fontWeight: 900,
  lineHeight: '150%',
  fontSize: 24,
  letterSpacing: 0
};
exports.tabletTitle3 = {
  fontFamily: 'Roboto',
  fontWeight: 700,
  lineHeight: '150%',
  fontSize: 20,
  letterSpacing: 0
};
exports.tabletTitle4 = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '145%',
  fontSize: 16,
  letterSpacing: 0.3
};
exports.tabletSubtitleLarge = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '133%',
  fontSize: 14,
  letterSpacing: 0.3
};
exports.tabletSubtitleMedium = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '125%',
  fontSize: 12,
  letterSpacing: 0.3
};
exports.tabletBodyLarge = {
  fontFamily: 'Roboto',
  fontWeight: 500,
  lineHeight: '150%',
  fontSize: 16,
  letterSpacing: 0
};
exports.tabletBodyMedium = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  lineHeight: '145%',
  fontSize: 14,
  letterSpacing: 0
};
exports.tabletBodySmall = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  lineHeight: '133%',
  fontSize: 12,
  letterSpacing: 0
};
exports.tabletCaption = {
  fontFamily: 'Roboto',
  fontWeight: 700,
  lineHeight: '133%',
  fontSize: 10,
  letterSpacing: 0,
  textCase: ''
};